import SmallBadge from "./assets/smallBadge";
import PedalBadge from './assets/pedalBadge';
import SmallTubeGuy from './assets/smallTubeGuy.jsx';

function analogStagePedalModel() {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
        }}>
            <div
            style={{
                backgroundColor: '#c1e1ce',
                width: '200px',
                height: '150px',
                display: 'flex',
                flexDirection: 'column',
                borderRadius: '6px'
            }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    height: '40%',
                    marginTop: '15px',
                    columnGap: '25px'
                    
                }}>

                <div style={{
                    backgroundColor: 'black',
                    width: '50px',
                    height: '50px',
                    borderRadius: '50%',
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        width: '15px',
                        height: '1.5px',
                        marginLeft: '30.5px',
                        marginTop: '35.5px',
                        transform: 'rotate(45deg)'
                    }}>

                    </div>
                </div>
                <div style={{
                    backgroundColor: 'black',
                    width: '50px',
                    height: '50px',
                    borderRadius: '50%',
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        width: '15px',
                        height: '1.5px',
                        marginLeft: '30.5px',
                        marginTop: '35.5px',
                        transform: 'rotate(45deg)'
                    }}>

                    </div>
                </div>
                </div>

                <div style={{
                    backgroundColor: '#fafdf2',
                    width: '90px',
                    height: '40px',
                    marginTop: '70px',
                    marginLeft: '55px',
                    borderRadius: '5px',
                    border: '1px solid #414243',
                    position: 'absolute'
                }}>
                    <div style={{
                         marginLeft: '5px',
                         marginTop: '0px',
                         
                    }}>
                    <PedalBadge />
                    <div style={{
                        marginLeft: '60px',
                        marginTop: '-22px',
                        position: 'absolute'
                    }}>
                        <SmallTubeGuy/>
                    </div>
                    </div>
                </div>

                <div style={{
                    marginTop: '35px',
                    width: '100%',
                    height: '15%',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    columnGap: '100px'
                }}>
                <div style={{
                        width: '23px',
                        height: '23px',
                        backgroundColor: 'silver',
                        borderRadius: '50%',
                    }}>
                        
                    
                    <div style={{
                        width: '20px',
                        height: '20px',
                        backgroundColor: 'white',
                        borderRadius: '50%',
                        boxShadow: '0px 0px 10px white',
                        marginLeft: '1.5px',
                        marginTop: '1.5px',
                        position: 'absolute'
                        }}>

                        </div>
                        </div>
                        <div style={{
                            backgroundColor: 'silver',
                            width: '18px',
                            height: '18px',
                            borderRadius: '50%',
                            border: '.5px solid black'
                        }}>
                            <div style={{
                                backgroundColor: 'silver',
                                width: '15px',
                                height: '15px',
                                borderRadius: '50%',
                                border: '.5px solid black',
                                marginLeft: '1px',
                                marginTop: '1px'
                            }}>

                            </div>

                        </div>
                </div>

            </div>
            
        </div>
    )
}

export default analogStagePedalModel;